import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { socket } from "../../helpers/bootstrap";
import { connect } from "react-redux";
import moment from "moment";
const AlertLog = ({ userId }) => {
    const [alertLogs, setAlertLogs] = useState([]);
    useEffect(() => {
        if (socket?.connected) {
            initEventListener();
            socket.emit("GET_ALERT_LOG", { userId });
        }
    }, []);

    const initEventListener = () => {
    //  Remove previous listener and init a new one
        socket.removeEventListener("ALERT_LOGS_" + userId);

        //  init new listener
        socket.on("ALERT_LOGS_" + userId, function(payload) {
            if (Array.isArray(payload.logs)) {
                setAlertLogs(payload.logs);
            }
        });
    };

    return (
        <div className="accordion bg-none" id="alert-logs-accordion">
            <div className="card bg-none border-0">
                <div className="card-header border-0" id="alert-logs-heading">
                    <h2 className="mb-0">
                        <button
                            tabIndex="-1"
                            className="btn border-0 btn-block text-left"
                            type="button"
                            data-toggle="collapse"
                            data-target="#alert-logs-collapse"
                            aria-expanded="true"
                            aria-controls="alert-logs-collapse"
                        >
                            Alert Logs
                        </button>
                    </h2>
                </div>

                <div
                    id="alert-logs-collapse"
                    className="collapse"
                    aria-labelledby="alert-logs-heading"
                    data-parent="#alert-logs-accordion"
                >
                    <div className="card-body">
                        <ul className="list-group">
                            {alertLogs.map((log, index) => {
                                const bgType =
                                    log.alertType === "error" ?
                                        "danger" :
                                        log.alertType;

                                return (
                                    <li
                                        key={log.alertId + "_AlertLog_" + index}
                                        className="list-group-item "
                                    >
                                        <span className={"text-dark"}>
                                            {log.msg}
                                        </span>{" "}
                                        <span className={"badge bg-" + bgType}>
                                            {log.alertType}
                                        </span>
                                        <div className={"text-muted"}>
                                            {moment(log.alertTime).format(
                                                "LLL"
                                            )}
                                        </div>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

AlertLog.propType = { alertLogs: PropTypes.array };

const mapStateToProps = state => ({ userId: state.contacts.contact.user_id });

export default connect(mapStateToProps)(AlertLog);